/**
 * useClickTracking
 * Global click listener that captures clicks on elements with data-track attribute
 *
 * Usage: Add data-track="button_name" to any element you want to track
 * Example: <button data-track="create_analysis">New Analysis</button>
 */

import { useEffect } from 'react';
import { eventService } from '@/services/tracking/eventService';

export function useClickTracking(): void {
  useEffect(() => {
    function handleClick(event: MouseEvent): void {
      const target = event.target as HTMLElement;

      // Walk up the DOM tree to find the closest element with data-track
      const trackElement = target.closest('[data-track]') as HTMLElement | null;
      if (!trackElement) return;

      const trackLabel = trackElement.getAttribute('data-track');
      if (!trackLabel) return;

      eventService.trackClick(trackLabel, window.location.pathname + window.location.search);
    }

    document.addEventListener('click', handleClick, { passive: true });

    return () => {
      document.removeEventListener('click', handleClick);
    };
  }, []);
}
